import React, { useState } from "react";
import { Box, Card, Divider, Grid, Icon, Input, Typography } from "@material-ui/core";
import MDEditor from "@uiw/react-md-editor"
import MarkdownEditorWithPreview from "components/MarkdownEditor/MarkdownEditorWithPreview";


export default function ReviewLectureSlide(props) {
    return (
        <Card style={{
            padding: "20px"
        }}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <label>Slide Header</label>
                    <Input variant="outlined" fullWidth
                        onChange={(e) => props.setSlideHeader(e.target.value)} value={props.slideHeader}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <label>Slide Content</label>
                    <div data-color-mode="light">
                        <MarkdownEditorWithPreview
                            value={props.slideContent}
                            onChange={(e) => props.setSlideContent(e)}
                            disabled={true}
                        />
                    </div>

                    {/* <ReactMarkdown>{props.slideContent}</ReactMarkdown> */}
                </Grid>
                <Grid item xs={12} sm={12}>
                    <label>Speaker Notes</label>
                    <Input variant="outlined" placeholder="Speaker Notes" fullWidth multiline rows={6}
                        onChange={(e) => props.setSpeakerNotes(e.target.value)} value={props.speakerNotes}
                    />
                </Grid>
            </Grid>
        </Card>
    );
}